import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout, FormError, authButton, authInput } from "@/components/auth/AuthLayout";
import { Splash } from "@/components/auth/RouteGuards";
import { useAuth } from "@/context/AuthContext";
import { authErrorMessage } from "@/lib/authErrors";
import { supabase } from "@/lib/supabase";

export default function ResetPassword() {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return <Splash />;
  if (!session) {
    return (
      <AuthLayout testId="reset-password-invalid" title="Link expired" subtitle="This password reset link is invalid or has already been used.">
        <Link to="/forgot-password" className={authButton} data-testid="reset-request-new-link">Request a new link</Link>
      </AuthLayout>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Use at least 8 characters.");
    if (password !== confirm) return setError("The passwords don't match.");
    setBusy(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (err) return setError(authErrorMessage(err));
    toast.success("Password updated. You're signed in.");
    navigate("/", { replace: true });
  };

  return (
    <AuthLayout testId="reset-password-page" title="Choose a new password" subtitle={`For ${session.user.email}`}>
      <form onSubmit={submit} className="space-y-3.5">
        <input type="password" required autoComplete="new-password" placeholder="New password (8+ characters)" value={password} onChange={(e) => setPassword(e.target.value)} className={authInput} data-testid="reset-password-input" />
        <input type="password" required autoComplete="new-password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={authInput} data-testid="reset-password-confirm-input" />
        <FormError>{error}</FormError>
        <button type="submit" disabled={busy} className={authButton} data-testid="reset-password-submit-button">
          {busy ? "Saving…" : "Save new password"}
        </button>
      </form>
    </AuthLayout>
  );
}
